import { createApiClient, responseData } from '#lib/api/client.js';

export const getMerchCart = async (
	fetchFn: typeof globalThis.fetch,
	productIds: string[]
) =>
	responseData(
		await createApiClient(fetchFn).GET('/website-api/pages/cart/merch', {
			params: { query: { productIds: productIds.join(',') } },
		})
	);
